import ArquivosService from '@/services/ArquivosService';

export default {
  data() {
    return {
      powerupService: null, // Mudar essa variavel no componente
      powerupEntityName: "Item", // Mudar essa variavel no componente
      downloadProgressData: {},
      dialogDeleteData: {},
      dialogDelete: false,
      dialogDetalhes: false,
      dialogDetalhesData: [],
      dialogDetalhesHeader: [
        { text: 'Resumo', value: 'parametro', sortable: false },
        { text: 'Valor', value: 'valor', sortable: false }
      ],
      dialogAcompanhamento: false,
      dialogAcompanhamentoData: { id: undefined, andamento: [] },
      dialogCreationLog: false,
      dialogCreationLogData: {},
      loadingDownloadArquivoById: false,
      loadingLogsTecnicos: false
    };
  },

  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    userIsAdmin() {
      return this.$store.getters.userIsAdmin;
    }
  },

  methods: {
    downloadItem(item, tituloArquivo = "") {
      const id = item.id;
      const nome = item.nome || item.titulo;

      const nomeReplace = (tituloArquivo) ? `Resultado ${this.powerupEntityName} ${id} ${tituloArquivo}.xlsx` : `Resultado ${this.powerupEntityName} ${id} ${nome}.xlsx`;
      const nomeCompletoArquivo = nomeReplace.replace(/ /g, '_');
      
      this.$set(this.downloadProgressData, id, { id }); 
      this.$toast.info("Preparando seu arquivo para download.", '', {position:'topRight', timeout: 2000});

      this.powerupService.download(id, {
        timeout: 60 * 60 * 1000,
        onDownloadProgress: (progressEvent) => {
          let progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          let isComputable = progressEvent.lengthComputable;

          this.$set(this.downloadProgressData, id, { progress, isComputable, id });
        }
      })
        .then(async res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", nomeCompletoArquivo);
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          this.$toast.error("Falha no download do resultado.", "", { position: "topRight" });
          console.error("Error: ", err);
        })
        .finally(() => {
          this.$delete(this.downloadProgressData, id);
        });
    },
    downloadArquivoById(id, nomeArquivo = "") {
      if (this.loadingDownloadArquivoById) return false;
      
      this.$toast.info("Preparando seu arquivo para download.", '', {position:'topRight', timeout: 2000});

      this.loadingDownloadArquivoById = true;

      ArquivosService.downloadArquivoById(id, {timeout: 60 * 60 * 1000})
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", nomeArquivo);
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          this.$toast.error("Falha no download do arquivo.", "", { position: "topRight" });
          console.error("Error: ", err);
        })
        .finally(() => this.loadingDownloadArquivoById = false);
    },

    downloadLogsTecnicos(id) {
      this.loadingLogsTecnicos = true;

      this.powerupService
        .baixarLogsTecnicos(id)
        .then(res => {

            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `logs-tecnicos-${id}.log`);
            document.body.appendChild(link);
            link.click();
        })
        .catch(() => {
            this.$toast.error('Falha no download dos logs técnicos.', '', { position: 'topRight' });
        })
        .finally(() => this.loadingLogsTecnicos = false);
    },

    /***
     * @param {String|Number} itemId Id da entidade
     * @param {String} eventName nome do event que vai recarregar a data table
     */
    executarItem(itemId, eventName = "rechargeTable") {
      this.powerupService.executar(itemId)
        .then(() => {
          this.$toast.info("Sua planilha será gerada em instantes. Por favor, aguarde.", "", { position: "topRight", timeout: 2000 });
          this.$emit(eventName);
        })
        .catch(err => {
          this.$toast.error(`Erro ao executar ${this.powerupEntityName}.`, "", { position: "topRight" });
          console.error(err);
        });
    },
    /***
     * @param {String|Number} itemId Id da entidade
     * @param {String} eventName nome do event que vai recarregar a data table
     */
    duplicarItem(itemId, eventName = "rechargeTable") {
      this.powerupService.duplicar(itemId)
        .then(() => {
          this.$emit(eventName);
        })
        .catch(err => {
          this.$toast.error(`Erro ao duplicar ${this.powerupEntityName}.`, "", { position: "topRight" });
          console.error(err);
        });
    },
    openDialogDelete(itemId, itemTitle) {
      this.dialogDeleteData = { id: itemId, titulo: itemTitle };
      this.dialogDelete = true;
    },
    /***
     * @param {String|Number} itemId Id da entidade
     * @param {String} eventName nome do event que vai recarregar a data table
     */
    deletarItem(itemId, eventName = "rechargeTable") {
      this.powerupService.deletar(itemId)
        .then(() => {
          this.$toast.success(`${this.powerupEntityName} removido(a) com sucesso.`, '', {position:'topRight'});
          this.$emit(eventName);
        })
        .catch(error => {
          this.$toast.error(`Erro ao deletar ${this.powerupEntityName}.`, '', {position:'topRight'});
          console.error(error);
        })

      this.dialogDelete = false;
    },
    canDeleteItem(item) {
      return item.status !== 'EXECUTANDO' && (this.userIsAdmin || this.user.id_hexa === item.usuario_id);
    },
    canRunItem(item) {
      return item.status !== 'EXECUTANDO' && item.status !== 'AGUARDANDO';// && item.status !== 'AGUARDANDO' && (this.userIsAdmin || this.user.id_hexa === item.usuario_id);
    },
    canEditItem(item) {
      return item.status !== 'EXECUTANDO' && item.status !== 'AGUARDANDO';// && (this.userIsAdmin || this.user.id_hexa === item.usuario_id);
    },
    openDialogAcompanhamento(item) {
      if (!['EXECUTANDO', 'AGUARDANDO'].includes(item.status)) { return };

      this.dialogAcompanhamentoData.id = item.id;
      this.dialogAcompanhamento = true;

      this.attAndamentoItem(item.id);
    },
    attAndamentoItem(itemId) {
      this.powerupService.andamento(itemId)
        .then((response) => {
          this.dialogAcompanhamentoData.andamento = response.data.andamento;
          this.$refs.dialogAcompanhamento.activatePusher();
        })
        .catch(error => {
          console.error(error);
          this.$toast.error(`Erro ao recuperar andamento do(a) ${this.powerupEntityName}.`, '', { position:'topRight' });
        })
    }
  }
}